import { render, staticRenderFns } from "./transferHistory.vue?vue&type=template&id=070894f7&scoped=true"
import script from "./transferHistory.vue?vue&type=script&lang=js"
export * from "./transferHistory.vue?vue&type=script&lang=js"
import style0 from "./transferHistory.vue?vue&type=style&index=0&id=070894f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070894f7",
  null
  
)

export default component.exports